import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/Wallpaper.jpg";
import {BsWindows} from "react-icons/bs";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function WindowsPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Wallpaper Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Discover expert wallpaper services in Charlotte NC. Our skilled team provides quality wallpaper installation and removal for your home improvement needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><BsWindows className={classes.servicesIcon}/> {languageContext.services.Wallpaper.title}</h1>
                <p className={classes.darkText}>{languageContext.services.Wallpaper.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.Wallpaper.text1}
                            <br/><br/>
                            <span>{languageContext.services.Wallpaper.text2}</span>
                            <br/>
                            {languageContext.services.Wallpaper.text3}
                            <br/><br/>
                            <span>{languageContext.services.Wallpaper.text4}</span>
                            <br/>
                            {languageContext.services.Wallpaper.text5}
                            <br/><br/>
                            <span>{languageContext.services.Wallpaper.text6}</span>
                            <br/>
                            {languageContext.services.Wallpaper.text7}
                            <br/><br/>
                            <span>{languageContext.services.Wallpaper.text8}</span>
                            <br/>
                            {languageContext.services.Wallpaper.text9}
                            <br/><br/>
                            <span>{languageContext.services.Wallpaper.text10}</span>
                            <br/>
                            {languageContext.services.Wallpaper.text11}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.imageHorizontal}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default WindowsPage;